import { render, staticRenderFns } from "./SwappHistory.vue?vue&type=template&id=76f1c375&"
import script from "./SwappHistory.vue?vue&type=script&lang=js&"
export * from "./SwappHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports